import { forwardRef, useState } from "react";
import { Icon } from "../Icon/Icon";

export const Input = forwardRef(
	(
		{
			label,
			placeholder,
			value,
			onChange,
			onBlur,
			hint,
			error,
			type = "text",
			disabled = false,
		},
		ref,
	) => {
		const [isFocused, setIsFocused] = useState(false);

		const handleClear = () => {
			onChange({ target: { value: "" } });
		};

		const containerClasses = `
    flex flex-col items-start gap-2 w-full
  `;

		const inputContainerClasses = `
    relative flex items-center h-[36px] py-2 w-full
    rounded-[4px] bg-color_background_grey_1
    ${error ? "border border-color_text_negative_3" : isFocused ? "border border-color_text_primary_3" : "border border-transparent"}
  `;

		const inputClasses = `
    w-full bg-transparent border-none outline-none px-2 pr-8 text-base
  `;

		const hintClasses = `
    w-full text-[14px] font-normal leading-[140%] tracking-[0.25px]
    ${error ? "text-color_text_negative_3" : "text-color_text_grey_3"}
  `;

		return (
			<div className={containerClasses}>
				{/* Label */}
				{label && (
					<label className="flex items-end gap-0 w-full Subtitle2">
						{label}
					</label>
				)}

				{/* Input Container */}
				<div className={inputContainerClasses}>
					<input
						ref={ref}
						type={type}
						placeholder={placeholder}
						value={value}
						disabled={disabled}
						onChange={onChange}
						onFocus={() => setIsFocused(true)}
						onBlur={(e) => {
							setIsFocused(false);
							onBlur?.(e);
						}}
						className={inputClasses}
						style={{ fontSize: "16px" }}
					/>

					{/* Clear button inside the input field */}
					{isFocused && value && (
						<button
							type="button"
							onClick={handleClear}
							className="absolute right-2 top-1/2 -translate-y-1/2 p-1"
							onMouseDown={(e) => e.preventDefault()}
						>
							<Icon iconName="cross_outline" size="Small" color="#999" />
						</button>
					)}
				</div>

				{/* Hint/Error */}
				{(hint || error) && (
					<div className={hintClasses}>{error ? error : hint}</div>
				)}
			</div>
		);
	},
);
